<template>

  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">

    <artisio-modal scrollable size="lg" :visible="modal.show" @hidden="onHidden" :title="$t('Cancel Invoice(s)')"
                   modal-class="mobile-full-screen" :ok-title="$t('Submit')" @ok.prevent="handleSubmit(onSubmit)"
                   :disable-submit-btn="!isFieldValid || isSelectionsInvalid()">
      <p>
        {{
          $t('Would you like to mark items listed within these Invoices as unsold? Please note that if there are seller settlements associated with the items being marked as unsold, they will remain in the settlement but with unsold status, these can be manually corrected later on. Would you like to proceed?')
        }}
      </p>
      <p>
        {{ $t("Select 'Yes' if you would like to mark items as Unsold, or 'No' if you would like the items to remain as sold.") }}
      </p>
      <artisio-table :fields="fields" :index="false" ref="invoiceTable" :items="modal.selectedItems" requires-min-height
                     :checkboxes="true" :enable-simple-search="false">
        <template slot="cell(invoice)" slot-scope="{item: invoice}">
          <span>
            {{ invoice.invoice_no }}
          </span>
        </template>
        <template slot="cell(buyer)" slot-scope="{item: invoice}">
          <template v-if="invoice.customer">
            <router-link :to="{ name: 'customers.dashboard', params: { id: invoice.customer.uuid }}">
              {{ invoice.customer.display_name }}
            </router-link>
          </template>
        </template>
        <template slot="cell(status)" slot-scope="{item: invoice}">
        <span v-if="invoice.status" v-as-status="invoice.status">
          {{ invoice.status | removeUnderscores | toUpperCaseFirst | translate }}
        </span>
          <span v-else v-as-status>{{ $t('N/A') }}</span>
        </template>
        <template slot="cell(sale)" slot-scope="{item: invoice}">
          <router-link
            v-if="invoice.auction && !enableContinuousAuction"
            v-permission="'view_auction'"
            :to="{ name: 'sales.view', params: { id: invoice.auction.uuid }}"
          >
            {{ invoice.auction.sale_no }}
          </router-link>
          <span v-else-if="invoice.auction && enableContinuousAuction">
            {{ invoice.auction.sale_no }}
          </span>
          <router-link
            v-else-if="invoice.deposit_sale_no && !enableContinuousAuction"
            v-permission="'view_auction'"
            :to="{
              name: 'sales.view',
               params: {
                id: invoice.deposit_reservations[0].auction_uuid
              }}"
          >
            {{ invoice.deposit_sale_no }}
          </router-link>
          <live-sale-ref
            v-if="invoice.auction && invoice.auction.live_reference"
            :href="invoice.auction.live_url"
            :label="invoice.auction.live_reference"
          />
        </template>
        <template slot="cell(items)" slot-scope="{item: invoice}">
          {{ getDataObject(invoice).total_lots }}
        </template>
        <template slot="cell(Total/Paid/Outstanding)" slot-scope="{item: invoice}">
          {{ invoice.total_amount | asCurrency(invoice.currency ? invoice.currency.symbol : null) }} /
          {{ invoice.paid_amount | asCurrency(invoice.currency ? invoice.currency.symbol : null) }} /
          {{ invoice.outstanding_amount | asCurrency(invoice.currency ? invoice.currency.symbol : null) }}
        </template>
        <template slot="cell(mark_as_unsold)" slot-scope="{item: invoice}">
          <cancel-modal-select-component
            @getValue="getValueFromSelect"
            :id="invoice.uuid"
          />
        </template>
      </artisio-table>
      <div class="confirm-wrapper">
        <label for="confirm">
          {{$t("Please type 'confirm' to confirm the cancellation")}}
        </label>
        <b-form-input id="confirm" v-model="confirmation" :state="isFieldValid" placeholder="confirm" required/>
      </div>

    </artisio-modal>
  </ValidationObserver>
</template>
<script>

  import {createNamespacedHelpers} from 'vuex'
  import ArtisioModal from "@/core/components/artisio-modal/ArtisioModal.vue";
  import ArtisioTable from "@/core/components/ams-table/ArtisioTable.vue";
  import LiveSaleRef from "@/core/components/common/LiveSaleRef.vue";
  import CancelModalSelectComponent from "@/modules/invoices/CancelModalSelectComponent.vue";
  import InvoicesService from "@/modules/invoices/InvoicesService";
  import i18n from "@/shared/i18n";

  const {mapActions, mapState} = createNamespacedHelpers('invoices');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "CancelInvoiceModal",
    components: {
      CancelModalSelectComponent,
      LiveSaleRef,
      ArtisioModal,
      ArtisioTable
    },
    data() {
      return {
        confirmation: '',
        elementsChoice: [],
        fields: [
          {key: 'invoice', label: i18n.t('Invoice')},
          {key: 'buyer', label: i18n.t('Buyer')},
          {key: 'sale', label: i18n.t('Sale')},
          {key: 'Total/Paid/Outstanding', label: `${i18n.t('Total')} / ${i18n.t('Paid')} / ${i18n.t('Outstanding')} `},
          {key: 'items', label: i18n.t('Items')},
          {key: 'status', label: i18n.t('Status')},
          {key: 'mark_as_unsold', label: i18n.t('Mark as Unsold')},
        ]
      }
    },

    computed: {
      ...mapState({
        modal: state => state.cancelInvoiceModal,
      }),
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      isFieldValid() {
        if (!this.confirmation.length) {
          return null
        } else {
          return this.confirmation === 'confirm'
        }
      }
    },
    methods: {
      ...mapActions(['hideCancelInvoiceModal', "getTableData"]),
      onHidden() {
        this.hideCancelInvoiceModal()
      },
      isSelectionsInvalid() {
        const item = this.elementsChoice.find(el => el.mark_invoice_items_unsold === null)
        return !!item
      },
      getDataObject(invoice) {
        if (invoice.status === 'cancelled' || invoice.is_credited) {
          return invoice.data;
        } else if (invoice.is_credit_note && invoice.credited_invoice) {
          return invoice.credited_invoice.data;
        }
        return invoice;
      },
      async onSubmit() {
        if (!this.isFieldValid || this.isSelectionsInvalid()) {
          return
        }
        let response = await InvoicesService.batchCancelInvoices(this.elementsChoice)
        if (response.success) {
          this.hideCancelInvoiceModal();
          this.getTableData();
          this.$refs.invoiceTable.clearSelected();
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else {
            this.$errorDialog(response.body);
          }
        }
      },
      getValueFromSelect(data) {
        const currentElement = this.elementsChoice.find(el => el.invoice_uuid === data.id)
        currentElement.mark_invoice_items_unsold = data.value
      }
    },
    mounted() {
      this.elementsChoice = this.modal.selectedItems.map(el => ({
          invoice_uuid: el.uuid,
          status: 'cancelled',
          mark_invoice_items_unsold: null
        }
      ))
    }
  }
</script>
<style scoped lang="scss">
  .confirm-wrapper {
    width: 50%;
    padding: 1em 0;
  }
</style>

